import { render } from "./SolicitudesComponent.vue?vue&type=template&id=7426bd7c&scoped=true"
import script from "./SolicitudesComponent.vue?vue&type=script&lang=js"
export * from "./SolicitudesComponent.vue?vue&type=script&lang=js"

import "./SolicitudesComponent.vue?vue&type=style&index=0&id=7426bd7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7426bd7c"]])

export default __exports__